var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnshort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07555 0.681702C5.27124 0.367404 5.72876 0.367404 5.92445 0.681702L9.78728 6.88572C9.99465 7.21878 9.75516 7.65 9.36283 7.65H1.63717C1.24484 7.65 1.00535 7.21878 1.21272 6.88572L5.07555 0.681702Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07555 17.7183C5.27124 18.0326 5.72876 18.0326 5.92445 17.7183L9.78728 11.5143C9.99465 11.1812 9.75516 10.75 9.36283 10.75H1.63717C1.24484 10.75 1.00535 11.1812 1.21272 11.5143L5.07555 17.7183Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnshort);
export default __webpack_public_path__ + "static/media/unshort.57718820c2e9086cadc3da7f48163d9e.svg";
export { ForwardRef as ReactComponent };